export default __webpack_public_path__ + "static/media/Wythe.0d670def.png";